import { React, useContext, useState, useEffect } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import { TableHeaderContext } from "../../Contexts/TableHeaderContext";
import ChargesBasedFilter from "../RefineSearchComponents/ChargeFilter";
import { useLocation, useNavigate } from "react-router";
import { TableDataContext } from '../../Contexts/TableDataContext';
import axios from "axios";
import { filterLocationUrl } from "../../Config/config";
import { UserContext } from "../../Contexts/UserContext";
import { toast } from "react-toastify";
import moment from 'moment';
import DefinitionModal from "../TagDefinitionModal";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";

export default function IOCRefineSearch({ customPathname }) {
    const {
        setSectors,
        onErrorHandler,
        isMobile,
        open,
        setOpen,
        refineSearchFilters,
        setrefineSearchFilters,
        iocPayload,
        setIocPayload 
    } = useContext(PeFilterContext);
    
    const { setCurrentPage } = useContext(TableDataContext);
    const { pathname } = useLocation();

    const [select, setSelected] = useState(0);
    const [isChargeOpen, setIsChargeOpen] = useState(false);
    
    const navigate = useNavigate();
    const { getToken } = useContext(UserContext);
    const location = useLocation();
    
    const isFromGlobalSearch = () => refineSearchFilters[pathname]?.globalSearch?.length > 0;
    const isFromSearchedList = () => refineSearchFilters[customPathname]?.globalSearch?.length > 0;

    // State management
    const [ChargeStateOptions, setChargeStateOptions] = useState([]);
    const [ChargeCityOptions, setChargeCityOptions] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [minChargeAmount, setMinChargeAmount] = useState("");
    const [maxChargeAmount, setMaxChargeAmount] = useState("");
    const [ChargeBasedSelected, setChargeBasedSelected] = useState([]);
    const [radioValue, setRadioValue] = useState(iocPayload?.charge_holder_name ? 'charge_holder' : 'company');
    const [showDefinitionModal, setShowDefinitionModal] = useState(false);
    const [defValues, setDefValues] = useState({});

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("charges");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    // Helper function to count applied filters for Charges section
    const getChargesFiltersCount = () => {
        const hasChargeAmount = (minChargeAmount !== "" || maxChargeAmount !== "") ? 1 : 0;
        const hasChargeDate = (startDate !== null || endDate !== null) ? 1 : 0;
        const hasChargeState = ChargeStateOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasChargeCity = ChargeCityOptions?.some(option => option.isChecked) ? 1 : 0;
        const hasChargeCompanies = ChargeBasedSelected?.length > 0 ? 1 : 0;
        return hasChargeAmount + hasChargeDate + hasChargeState + hasChargeCity + hasChargeCompanies;
    };

    // Initialize filters from iocPayload
    useEffect(() => {
        if (iocPayload) {
            setRadioValue(iocPayload?.charge_holder_name?.length > 0 ? 'charge_holder' : 'company');
            const initialFilterState = {
                chargeState: iocPayload?.state || [],
                chargeCity: iocPayload?.city || [],
                chargeCompanies: iocPayload?.company || [],
                chargeHolders: radioValue === 'charge_holder' ? iocPayload?.charge_holder_name : [],
                chargeDate: iocPayload?.charge_date?.from_date && iocPayload?.charge_date?.to_date ? [{
                    id: 0,
                    name: `${moment(iocPayload.charge_date.from_date).format('YYYY-MM-DD')} - ${moment(iocPayload.charge_date.to_date).format('YYYY-MM-DD')}`,
                    value: {
                        'from_date': moment(iocPayload.charge_date.from_date).format('YYYY-MM-DD'),
                        'to_date': moment(iocPayload.charge_date.to_date).format('YYYY-MM-DD'),
                    }
                }] : [],
                chargeAmount: iocPayload?.charge_amount?.from_amt && iocPayload?.charge_amount?.to_amt ? [{
                    id: 0,
                    name: `${iocPayload.charge_amount.from_amt} Cr - ${iocPayload.charge_amount.to_amt} Cr`,
                    value: {
                        'from_amt': parseInt(iocPayload.charge_amount.from_amt),
                        'to_amt': parseInt(iocPayload.charge_amount.to_amt)
                    }
                }] : []
            };

            setrefineSearchFilters(prev => ({
                ...prev,
                [customPathname]: initialFilterState
            }));
        }
    }, [iocPayload]);

    // Fetch location data
    useEffect(() => {
        const chargeStateIds = refineSearchFilters[customPathname]?.chargeState?.map(value => value.id) || [];
        const chargeCityIds = refineSearchFilters[customPathname]?.chargeCity?.map(value => value.id) || [];

        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],
            type: 5
        }, {
            headers: {
                "Authorization": getToken()
            }
        })
        .then(response => {
            if (response.status === 200) {
                setChargeStateOptions(response.data.iocStates?.map(option => ({
                    ...option,
                    isChecked: chargeStateIds.includes(option.id)
                })) || []);
                setChargeCityOptions(response.data.iocCities?.map(option => ({
                    ...option,
                    isChecked: chargeCityIds.includes(option.id)
                })) || []);
            }
        })
        .catch(onErrorHandler);
    }, [refineSearchFilters]);

    const onChargeStateChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);

        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: ids,
            city: [],
            type: 5
        }, {
            headers: {
                "Authorization": getToken()
            }
        })
        .then(response => {
            if (response.status === 200) {
                setChargeCityOptions(response.data?.iocCities || []);
            }
        })
        .catch(onErrorHandler);
    };

    const validateFilters = () => {
        const selectedCharge = ChargeBasedSelected?.map(option => option.name);
        
        if (radioValue && selectedCharge?.length === 0) {
            toast.warning(`Please choose ${radioValue === "company" ? "Company name" : "Charge holder"}`);
            return false;
        }

        if (minChargeAmount !== "" && maxChargeAmount !== "") {
            const minCharge = Number(minChargeAmount);
            const maxCharge = Number(maxChargeAmount);
            
            if (minCharge <= 0) {
                toast.warning('Minimum charge amount must be greater than 0');
                return false;
            }
            
            if (minCharge > maxCharge) {
                toast.warning(`Maximum charge amount must be greater than or equal to ${minCharge}`);
                return false;
            }
        }

        return true;
    };

    const applyFilter = () => {
        const selectedChargeState = ChargeStateOptions?.filter(option => option.isChecked);
        const selectedChargeCity = ChargeCityOptions?.filter(option => option.isChecked);
        
        const isChargeEmpty = minChargeAmount === "" && 
                            maxChargeAmount === "" && 
                            startDate == null && 
                            endDate == null && 
                            radioValue == null && 
                            selectedChargeState.length === 0 && 
                            selectedChargeCity.length === 0;
       
        if (isChargeEmpty) {
            setIsChargeOpen(false);
        }

        const newFilterState = {
            chargeState: selectedChargeState,
            chargeCity: selectedChargeCity,
            chargeCompanies: radioValue === 'company' ? ChargeBasedSelected : [],
            chargeHolders: radioValue === 'charge_holder' ? ChargeBasedSelected : [],
            chargeDate: startDate != null && endDate != null ? [{
                id: 0,
                name: `${moment(startDate).format('YYYY-MM-DD')} - ${moment(endDate).format('YYYY-MM-DD')}`,
                value: {
                    'from_date': startDate != null ? moment(startDate).format('YYYY-MM-DD') : null,
                    'to_date': endDate != null ? moment(endDate).format('YYYY-MM-DD') : null,
                }
            }] : [],
            chargeAmount: minChargeAmount !== "" && maxChargeAmount !== "" ? [{
                id: 0,
                name: `${minChargeAmount} Cr - ${maxChargeAmount} Cr`,
                value: {
                    'from_amt': parseInt(minChargeAmount),
                    'to_amt': parseInt(maxChargeAmount)
                }
            }] : []
        };

        // Update both states atomically
        setIocPayload({
            company: radioValue === 'company' ? ChargeBasedSelected : [],
            charge_holder_name: radioValue === 'charge_holder' ? ChargeBasedSelected : [],
            charge_date: newFilterState.chargeDate?.at(0)?.value,
            charge_amount: newFilterState.chargeAmount?.at(0)?.value,
            state: selectedChargeState,
            city: selectedChargeCity,
        });

        setrefineSearchFilters(prev => ({
            ...prev,
            [location.pathname]: newFilterState
        }));
    };

    const refineSearchFilter = (event) => {
        event.preventDefault();
        
        if (isMobile) {
            setOpen(!open);
        }

        if (!validateFilters()) {
            return;
        }

        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: { globalSearch: [] }
        }));

        setCurrentPage(1);
        applyFilter();
        setSelected(false);

        if (location.pathname !== customPathname) {
            navigate(customPathname);
        }
    };

    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {}
        }));
        setSelected(0);
        setIsChargeOpen(false);
        setIocPayload({  });

        
        if (location.pathname !== customPathname) {
            navigate(customPathname);
        }
    };

    const defCloseHandler = () => {
        setShowDefinitionModal(false);
        setDefValues({});
    };

    return (
        <div className="bg-white">
            <div className="h-full no-scrollbar">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full">
                    <main className="h-full w-full py-4">
                        <div className="grid grid-cols-8 gap-4 h-full">
                            {/* Left column - Headers */}
                            <div className="h-full col-span-2 flex flex-col gap-2 border-r border-gray-300 pr-4">
                                <div 
                                    className={`cursor-pointer p-3 rounded-lg transition-colors ${
                                        activeFilterSection === 'charges' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'charges' ? null : 'charges')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-2">
                                            <span className="font-medium">Charges</span>
                                            {getChargesFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-2 py-1 min-w-[20px] text-center ${activeFilterSection === 'charges' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getChargesFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'charges' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>
                            </div>
                            
                            {/* Right column - Filters */}
                            <div className="h-full col-span-6 overflow-y-auto">
                                {activeFilterSection === 'charges' && (
                                    <div className="space-y-4">
                                        <ChargesBasedFilter
                                            customPathname={customPathname}
                                            accordionClick={() => setIsChargeOpen(prev => !prev)}
                                            open={isChargeOpen}
                                            ChargeStateOptions={ChargeStateOptions}
                                            setChargeStateOptions={setChargeStateOptions}
                                            ChargeCityOptions={ChargeCityOptions}
                                            setChargeCityOptions={setChargeCityOptions}
                                            ChargeBasedSelected={ChargeBasedSelected}
                                            setChargeBasedSelected={setChargeBasedSelected}
                                            minChargeAmount={minChargeAmount}
                                            setMinChargeAmount={setMinChargeAmount}
                                            maxChargeAmount={maxChargeAmount}
                                            setMaxChargeAmount={setMaxChargeAmount}
                                            startDate={startDate}
                                            setStartDate={setStartDate}
                                            endDate={endDate}
                                            setEndDate={setEndDate}
                                            radioValue={radioValue}
                                            setRadioValue={setRadioValue}
                                            onChargeStateChange={onChargeStateChange}
                                            menu="ioc"
                                            isPopupOpen={openFilterPopup === 'charge'}
                                            setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'charge' : null)}
                                        />
                                    </div>
                                )}
                                
                                {!activeFilterSection && (
                                    <div className="flex items-center justify-center h-40 text-gray-500">
                                        <p>Select a filter category from the left to view available filters</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </main>
                </form>
            </div>
            {showDefinitionModal && <DefinitionModal values={defValues} onClose={defCloseHandler} CFSRefine={true} />}
        </div>
    );
}